import { asType, mapObject, merge } from "scripts/FunctionsBundle";

// General Object
abstract class strictObject {
  // Every permitible parameter type

  readonly _specifics: {
    [ a: string ]: Array<string>
  } = {  };

  update(initializer: any) {
    Object.keys(initializer).forEach((key) => {
      if (
        this[key] !== undefined && // Si el objeto contiene la propiedad
        typeof this[key] === typeof initializer[key] && ( // Y la propiedad es del mismo tipo
        this._specifics[key] === undefined || ( // Y no está restringida a ciertos valores
        this._specifics[key] !== undefined && // O si está restringida a ciertos valores
        this._specifics[key].includes(initializer[key])))) { // Pero cumple con los requisitos
        this[key] = initializer[key]; // Entonces se inicializa la propiedad
      }
    });
  }

  constructor(initializer: any = {}) {
    this.update(initializer);
  }
}

// GameObject from Firestore 'games'
export class GameObject extends strictObject {
  name: string = "";
  shortName: string = "";
  description: string = "";
  platform: string = "Nintendo Switch";
  link: string = "/";
  color: string = "#000000";
  _specifics = {
    platform: ["Nintendo Switch", "PC"]
  };

  constructor(initializer: any = {}) {
    super();
    this.update(initializer);
  }
}

// ###############################################################################
// ########################### ANIMAL CROSSING OBJECTS ###########################

// Animal Crossing Capturapedia Class
export abstract class ACNH_Element extends strictObject {
  name: string = "";
  price: number = 0;
  image: string = "";
  considerations: string = "";

  static readonly classes = {
    bichos: class extends ACNH_Element {
      month: string = "000000000000";
      hour: string = "000000000000000000000000";

      habitat: string = "Césped";
      _specifics = {
        habitat: ["Césped", "Flores", "Aire", "Suelo de piedra", "Agua","Playa", "Pared de árbol", "Copa de árbol", "Tronco de árbol", "Rocas", "Debajo de Rocas", "Específico"],
      };
    },

    peces: class extends ACNH_Element {
      month: string = "000000000000";
      hour: string = "000000000000000000000000";

      habitat: string = "Mar";
      shadow: string = "Pequeña";
      _specifics = {
        habitat: ["Mar", "Estanque", "Río", "Cascada", "Muelle", "Desembocadura"],
        shadow: ["Pequeña", "Grande", "Alargada", "c/ Aleta Dorsal"],
      };
    },

    marinas: class extends ACNH_Element {
      month: string = "000000000000";
      hour: string = "000000000000000000000000";

      speed: string = "Estática";
      shadow: string = "Pequeña";
      bubbles: string = "Pocas";
      _specifics = {
        speed: ["Estática", "Lenta", "Moderada", "Rápida"],
        shadow: ["Pequeña", "Media", "Grande"],
        bubbles: ["Pocas", "Moderadas", "Muchas"],
      };
    },

    otros: class extends ACNH_Element {
      type: string = "Vegetación";
      _specifics = {
        type: ["Vegetación", "Conchas", "Otros"],
      };
    },

    muebles: class extends ACNH_Element {
      crafteable: boolean = false;
    }
  }

  constructor(initializer: any = {}) {
    super();
    this.update(initializer);
  }
};

// Quick Capturapedia book
export type Capturapedia = {
  [Property in keyof typeof ACNH_Element.classes]?: typeof ACNH_Element.classes[Property]["prototype"]
};

// ###############################################################################
// ########################### MISCELLANEOUS #####################################

/**
 * Provides basic prop structure for functional components
 * @param T Type parameter assigned for the `LegacyRef`
 */
export type Base = {
  /** Overrides any other `className` passed */
  className?: string;
  /** Overrides any other `ref` passed */
  // _ref?: React.LegacyRef<T>;
  /** Overrides any other `style` passed */
  _style?: import("react").CSSProperties;
};



type cat = { [Property in keyof Capturapedia]-?: Capturapedia[Property]; }[keyof Capturapedia];

type cat2 = Partial<cat>;



var asadad: cat2 = { name: "", };

const as = asType<{ [Property in keyof Capturapedia]-?: Capturapedia[Property] }>(mapObject(ACNH_Element.classes, (cat, _, obj) => {return new obj[cat]();} ));

const aaa = Object.values(as);

const aa = merge(ACNH_Element.classes.bichos.prototype, ACNH_Element.classes.marinas.prototype);

type test<T extends object, K extends keyof T> = T[K];

var bb: typeof ACNH_Element.classes.bichos.prototype;

var a: test<typeof bb, "habitat">;